import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// =============================================================================
// BUILD INFO & CACHE BUSTING
// =============================================================================
const BUILD_ID = process.env.REACT_APP_BUILD_ID || new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14);
const BUILD_TIMESTAMP = new Date().toISOString();

// Log build info on app start
console.log(`%c[BlueLock Staff Manager]`, 'color: #1e40af; font-weight: bold; font-size: 14px;');
console.log(`%cBUILD_ID: ${BUILD_ID}`, 'color: #059669; font-weight: bold;');
console.log(`%cStartup: ${BUILD_TIMESTAMP}`, 'color: #6b7280;');
console.log(`%cAPI: ${process.env.REACT_APP_BACKEND_URL}`, 'color: #6b7280;');

// Store BUILD_ID globally for components to access
window.__BLUELOCK_BUILD_ID__ = BUILD_ID;
window.__BLUELOCK_BUILD_TIMESTAMP__ = BUILD_TIMESTAMP;

// =============================================================================
// SERVICE WORKER UNREGISTRATION (Prevents stale cache issues)
// =============================================================================
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    if (registrations.length > 0) {
      console.log(`[Cache] Unregistering ${registrations.length} service worker(s)...`);
      registrations.forEach((registration) => {
        registration.unregister().then((success) => {
          if (success) {
            console.log('[Cache] Service worker unregistered successfully');
          }
        });
      });
    }
  }).catch((error) => {
    console.warn('[Cache] Error checking service workers:', error);
  });
  
  // Clear caches
  if ('caches' in window) {
    caches.keys().then((cacheNames) => {
      if (cacheNames.length > 0) {
        console.log(`[Cache] Clearing ${cacheNames.length} cache(s)...`);
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      }
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
